import { Conduit } from '@campingvision/conduit';
import { authentication } from '../interceptors/request';

const conduit = new Conduit(
  `${process.env.TWENTY_API_URL}core/affiliates/`,
  [],
  [authentication],
  [],
  false,
  3 * 60 * 1000,
  true,
);

export default {
  /**
   * @returns AxiosPromise
   */
  getAffiliates() {
    return conduit.get('');
  },

  /**
   * @param affiliateId
   * @returns AxiosPromise
   */
  getAffiliate(affiliateId) {
    return conduit.get(`${affiliateId}`);
  },

  /**
   * @param payload
   * @returns AxiosPromise
   */
  createAffiliate(payload) {
    return conduit.post('', payload);
  },

  /**
   * @param affiliateId
   * @param params
   * @returns AxiosPromise
   */
  updateAffiliate(affiliateId, params) {
    return conduit.put(`${affiliateId}`, params);
  },

  /**
   * @param affiliateId
   * @param domainIds
   * @returns AxiosPromise
   */
  syncDomains(affiliateId, domainIds) {
    return conduit.put(`${affiliateId}/domains`, { domainIds });
  },

  /**
   * @param affiliateId
   * @param affiliateDomainId
   * @param formData
   * @returns AxiosPromise
   */
  updateLogo(affiliateId, affiliateDomainId, formData) {
    return conduit.post(`${affiliateId}/domains/${affiliateDomainId}/logo`, formData);
  },

  /**
   * @returns AxiosPromise
   */
  getSuppliers() {
    return conduit.get('suppliers');
  },

  /**
   * @param affiliateId
   * @param params
   * @returns AxiosPromise
   */
  syncSupplier(affiliateId, params) {
    return conduit.post(`${affiliateId}/domains/suppliers`, params);
  },

  /**
   * @param affiliateId
   * @param affiliateDomainId
   * @param supplierId
   * @returns AxiosPromise
   */
  deleteSupplier(affiliateId, affiliateDomainId, supplierId) {
    return conduit.delete(`${affiliateId}/domains/${affiliateDomainId}/suppliers/${supplierId}`);
  },
};



// WEBPACK FOOTER //
// ./src/services/affiliates-service.js